import React, { Component } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../util/IconButton';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ClienteModal from './cliente_modal';

export default class Cliente extends Component {
    state = {
        visualizar: false,
    };

    render() {
        const { visualizar } = this.state;
        const { cliente, reativar, excluir, load } = this.props;
        const { codigo, nome } = cliente;

        return (
            <Row className="align-items-center">
                <Col md="auto" className="cliente-clientes-item-codigo">{codigo}</Col>
                <Col>{nome}</Col>
                <Col md="auto">
                    <IconButton
                        icon={faSearch}
                        onClick={() => this.setState({ visualizar: true })} />
                    {visualizar !== false && (
                        <ClienteModal
                            add={false}
                            show={visualizar === true}
                            reativar={reativar}
                            excluir={excluir}
                            cliente={cliente}
                            onSuccess={load}
                            onHide={() => {
                                this.setState({ visualizar: null });
                                setTimeout(() => this.setState({ visualizar: false }), 500);
                            }} />
                    )}
                </Col>
            </Row>
        )
    }
}